// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Heading, Text } from '@chakra-ui/react';


const HighScore = ({ score, onNewHighScore }) => {
  const [highScore, setHighScore] = useState(0);

  useEffect(() => {
    const storedHighScore = localStorage.getItem('highScore');
    if (storedHighScore) {
      setHighScore(parseInt(storedHighScore, 10));
    }
  }, []);

  useEffect(() => {
    if (score > highScore) {
      const scoreDifference = score - highScore;
      setHighScore(score);
      localStorage.setItem('highScore', score);
      if (onNewHighScore) {
        onNewHighScore(scoreDifference);
      }
    }
  }, [score, highScore, onNewHighScore]);

  return (
    <div>
      <Heading as="h5" size="xs" color="blue.500"></Heading>
      <Text fontSize="14px" color="blue.500" fontWeight="normal">HighScore: {highScore}</Text>
    </div>
  );
};

export default HighScore;
